import { useQuery } from "@tanstack/react-query";
import { SUPABASE_URL } from "@/integrations/supabase/client";
import { apiFetch } from "@/lib/api-fetch";
import { Moeda } from "@/utils/money";

/** Reais por dólar (Plataforma > Parâmetros), para comparar verba em dólar com pretensão em reais. */
export function useCotacaoUsd(): number | undefined {
  const { data } = useQuery({
    queryKey: ["moedas", "cotacoes"],
    staleTime: 60 * 60 * 1000,
    queryFn: () => apiFetch<Record<string, number>>(`${SUPABASE_URL}moedas/cotacoes`),
  });
  return data?.[Moeda.USD];
}
